
document.addEventListener('DOMContentLoaded', function () {
  function goToQuote(e){
    var quote = document.getElementById('quote');
    if (quote) {
      e.preventDefault();
      quote.scrollIntoView({behavior:'smooth', block:'start'});
      try { history.replaceState(null, '', '#quote'); } catch(err) {}
      var first = quote.querySelector('input,select,textarea,button');
      if(first) setTimeout(function(){ first.focus({preventScroll:true}); }, 650);
    }
  }
  document.querySelectorAll('.pb-header-quote-v3622, a[href="#quote"], a[href="/#quote"]').forEach(function(a){
    a.setAttribute('href','#quote');
    a.addEventListener('click', goToQuote);
  });
});
